import { Menu } from 'antd';
import React, { useEffect, useState } from 'react';
import '../header/header.css';
import { useLocation, useNavigate } from 'react-router-dom';
import { useMenu } from '../context/MenuContext.jsx';
import { MenuOutlined, CloseOutlined } from '@ant-design/icons';
import { menuItems } from '/src/constants/constants.jsx';

const PageMenu = () => {
    const { current, setCurrent, theme } = useMenu();
    const navigate = useNavigate();
    const location = useLocation();
    const [mobileMenuVisible, setMobileMenuVisible] = useState(false);

    const visibleMenuItems = menuItems.filter((item) => item.visibility);

    useEffect(() => {
        const matchedItem = menuItems.find(
            (item) => item.path === location.pathname,
        );
        if (matchedItem) {
            setCurrent(matchedItem.key);
        }

        if (matchedItem && !matchedItem.visibility) {
            navigate(visibleMenuItems[0].path);
        }
    }, [location.pathname, setCurrent, visibleMenuItems]);

    const handleMenuClick = (e) => {
        const selectedItem = menuItems.find((item) => item.key === e.key);
        if (selectedItem) {
            setCurrent(selectedItem.key);
            setMobileMenuVisible(false);
            navigate(selectedItem.path);
        }
    };

    const toggleMobileMenu = () => {
        setMobileMenuVisible(!mobileMenuVisible);
    };

    return (
        <div className="menu_block footer-menu-block">
            <Menu
                onClick={handleMenuClick}
                selectedKeys={[current]}
                mode="horizontal"
                items={visibleMenuItems}
                className="menu-desktop footer-menu-desktop"
                disabledOverflow={true}
            />
            <div
                className={`menu-mobile ${mobileMenuVisible ? 'visible' : ''}`}>
                <div className="menu-mobile-close" onClick={toggleMobileMenu}>
                    <CloseOutlined />
                </div>
                <Menu
                    onClick={handleMenuClick}
                    selectedKeys={[current]}
                    mode="inline"
                    items={visibleMenuItems}
                    className="menu-mobile-content"
                />
            </div>
            <div className="menu-mobile-button" onClick={toggleMobileMenu}>
                <MenuOutlined
                    style={{
                        color:
                            theme === 'Dark'
                                ? 'var(--primary-color)'
                                : 'var(--primary-color1)',
                    }}
                />
            </div>
        </div>
    );
};

export default PageMenu;
